import {useCallback, useState} from 'react';
import {
  MessageFromParent,
  MessageFromParentType,
} from './Providers/ParentMessageBusProvider/MessageFromParent';
import {devLog} from './helpers/dev';
import {useParentMessageHandler} from './Providers/ParentMessageBusProvider';

// should move this to the widget framework;
// it already knows about being iframed
export function useDocumentVisibility() {
  const [documentVisibility, setDocumentVisibility] =
    useState<DocumentVisibilityState>('visible');

  const handler = useCallback((message: MessageFromParent) => {
    if (message.type === MessageFromParentType.DocumentVisibilityChange) {
      devLog('Updating document visibility from parent', {
        documentVisibility: message.data.documentVisibility,
      });
      setDocumentVisibility(message.data.documentVisibility);
    }
  }, []);
  useParentMessageHandler(handler);

  return {documentVisibility};
}
